require('./_wks-define')('asyncIterator');



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/es7.symbol.async-iterator.js